// Thin wrapper around the /api/phoneai/* endpoints. Reuses the shared axios
// instance so JWT + x-wallet-address headers are attached automatically.
import api from './api';

export const askPhoneAI = async (message) => {
  const res = await api.post('/phoneai/ask', { message });
  return res.data; // { assistant_reply, pending_action?, tools_used, error? }
};

export const getPhoneAIHistory = async () => {
  const res = await api.get('/phoneai/history');
  return res.data?.messages || [];
};

export const clearPhoneAIHistory = async () => {
  const res = await api.post('/phoneai/clear');
  return res.data;
};

// Confirm a pending action returned from /phoneai/ask. The actionToken is HMAC
// -signed server-side over {tool, args, walletAddress, exp:5min}, so the
// caller cannot tamper with the args between preview and execute.
export const executePhoneAIAction = async (actionToken) => {
  const res = await api.post('/phoneai/execute', { action_token: actionToken });
  return res.data; // { assistant_reply, result, error }
};

// Wallet-sign handoff: the user signed a prepared tx in their own wallet and
// got a tx hash back. POST that hash so PHONE can verify/record it and reply.
// PHONE NEVER signs — this is purely "I, the user, signed it; here's proof."
export const walletAckPhoneAI = async (actionToken, txHash) => {
  const res = await api.post('/phoneai/wallet-ack', {
    action_token: actionToken,
    tx_hash: txHash,
  });
  return res.data; // { assistant_reply, result }
};
